import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";
import work1 from "../../../src/images/work/6.jpg";

import HeaderImage from "../../../src/images/design-ads/header.png";

import img1 from "../../images/design-ads/icons-design/1.jpg";
import img2 from "../../images/design-ads/icons-design/2.jpg";
import img3 from "../../images/design-ads/icons-design/3.jpg";
import img4 from "../../images/design-ads/icons-design/4.jpg";
import img5 from "../../images/design-ads/icons-design/5.jpg";
import img6 from "../../images/design-ads/icons-design/6.jpg";
import img7 from "../../images/design-ads/icons-design/7.jpg";
import img8 from "../../images/design-ads/icons-design/8.jpg";
import img9 from "../../images/design-ads/icons-design/9.jpg";
import img10 from "../../images/design-ads/icons-design/10.jpg";
import img11 from "../../images/design-ads/icons-design/11.jpg";
import img12 from "../../images/design-ads/icons-design/12.jpg";
import img13 from "../../images/design-ads/icons-design/13.jpg";
import img14 from "../../images/design-ads/icons-design/14.jpg";
import img15 from "../../images/design-ads/icons-design/15.jpg";
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
// const ImageColumn = tw(Column)`md:w-0/12 lg:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  // tw`md:w-12/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-cover bg-center h-full`,
]);

const StatCol = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-0 md:py-0`;
const StatImageColumn = tw(Column)`md:w-3/12 lg:w-3/12 flex-shrink-0 h-80 md:h-auto`;
const StatTextColumn = styled(Column)(props => [
  tw`md:w-9/12 mt-0 md:mt-0`,
  props.textOnLeft ? tw`md:mr-1 lg:mr-1 md:order-first` : tw`md:ml-1 lg:ml-1 md:order-last`
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-4`

const Statistics = tw.div`mt-8 lg:mt-8 xl:mt-0 flex flex-wrap`
const Statistic = tw.div`text-lg sm:text-2xl lg:text-3xl w-1/2 mt-4 lg:mt-4 text-center md:text-left`
const Value = tw.p`font-bold text-primary-300 text-sm`
const Key = tw.p`text-center md:text-left text-sm text-secondary-100 mt-1`
// const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
// const ImageColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-80 md:h-auto`;
export default ({ textOnLeft = false }) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects

  const statistics = [
    {
      key: "Introduce strategic marketing frameworks and processes to ensure profitablity & growth.",
      value: "Strategy & Planning",
      img: img1,
    },
    {
      key: "strengthen your competitive differences &  the emotional connection with your audience.",
      value: "Branding & Creative Design",
      img: img9,
    },
    {
      key: "Imporive online visibility, create leads & sales, provide enhanced customer experience.",
      value: "Website & Technology",
      img: img2,
    },
    {
      key: "Increase leads, sales and customer connection with an exceptional, marketing led team",
      value: "Digital Marketing & Advertising",
      img: img10,
    },
    {
      key: "Develop engaging content that connects with your audience across all platforms.",
      value: "Creative concept & Visual storytelling",
      img: img3,
    },
    {
      value: "Branding & brand identity design",
      key: "Create a strong, memorable brand that resonates with your target audience.",
      img: img11,
    },
    {
      value: "Graphic design for ads and campaigns",
      key: "Design compelling visuals for your advertising campaigns.",
      img: img5,
    },
    {
      value: "Digital ad creatives (web, display, banners)",
      key: "Craft eye-catching digital advertisements to boost engagement.",
      img: img12,
    },
    {
      value: "Social media ad design & content creatives",
      key: "Design compelling visuals for your social media advertising campaigns.",
      img: img6,
    },
    {
      value: "Print ad design (flyers, brochures, posters)",
      key: "Create visually appealing print advertisements to capture attention.",
      img: img13,
    },
    {
      value: "Visual direction & art direction",
      key: "Define the visual identity & aesthetic direction for all marketing materials.",
      img: img7,
    },
    {
      value: "Campaign theme & messaging design",
      key: "Develop a cohesive campaign theme & messaging strategy that resonates with your audience.",
      img: img14,
    },
    {
      value: "Motion graphics & short promo visuals",
      key: "Create dynamic motion graphics & short promotional visuals for digital campaigns.",
      img: img8,
    },
    {
      value: "Event & promotional design assets",
      key: "Design compelling assets for events & promotional activities.",
      img: img15,
    }
  ]

  return (
    <Container>
      <Image imageSrc={HeaderImage} alt="Header" className="w-full h-64 object-cover" />
      <TwoColumn>

        {/* <ImageColumn>

          <Image imageSrc={work1} />
        </ImageColumn> */}
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Heading>We are experts in bringing brands to life digitally through design and development.</Heading>
            <Description>Vizual Ads is a progressive and insightful design agency, technically and creatively skilled to translate your brand into its best digital self. Our design and development approach creates impactful, engaging brands and immersive digital experiences that bring you a return on creativity.</Description>
            <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <StatCol>
                    <StatImageColumn>
                      <img src={statistic.img} alt={statistic.value} className="w-12 h-12 mb-2" />
                    </StatImageColumn>
                    <StatTextColumn>
                      <Value>{statistic.value}</Value>
                      <Key>{statistic.key}</Key>
                    </StatTextColumn>
                  </StatCol>
                  {/* <img src={statistic.img} alt={statistic.value} className="w-12 h-12 mb-2" />
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key> */}
                </Statistic>
              ))}
            </Statistics>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
